var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEnomoLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 2297,
    height: 654,
    viewBox: "0 0 2297 654",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2045.68 352.826C2064.23 278.401 2129.1 238.095 2183.09 250.368C2236.23 262.448 2274.8 325.018 2256.32 399.174C2237.77 473.599 2172.9 513.905 2118.91 501.632C2065.77 489.552 2027.2 426.982 2045.68 352.826Z",
    stroke: "white",
    strokeWidth: 72.201
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1366.68 352.826C1385.23 278.401 1450.1 238.095 1504.09 250.368C1557.23 262.448 1595.8 325.018 1577.32 399.174C1558.77 473.599 1493.9 513.905 1439.91 501.632C1386.77 489.552 1348.2 426.982 1366.68 352.826Z",
    stroke: "white",
    strokeWidth: 72.201
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1686.94 212.439L1629.18 539.751H1698.97L1731.22 356.841L1774.75 539.751H1785.88L1891 368L1860.22 539.751H1932.42L1990.18 212.439H1917.98L1803 401.5L1757.5 212.439H1686.94Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M980.361 539.751H1052.54L1087 345L1182.5 539.751H1254.73L1312.49 212.439H1240.28L1205.63 407.382L1110.32 212.439H1038.12L980.361 539.751Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M763.761 212.818H987.076L975.55 277.799H822.484L811.895 337.967H898.536L886.502 405.354H799.861L787.828 472.742H951.483L939.45 540.13H706L763.761 212.818Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M269.627 566.203L253.944 653.56L565.587 540.408L581.253 451.731L269.627 566.203Z",
    fill: "#DF0043"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M623.547 213.084L311.26 327.002L295.978 416L607.943 302.465L623.547 213.084Z",
    fill: "#DF0043"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M126.785 172.209L84.7327 411.058L169.985 379.466L196.354 230.584L338.395 178.763L353.678 89.7644L126.785 172.209Z",
    fill: "#DF0043"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M57.3167 113.918L126.785 172.209L353.678 89.7644L469.946 186.673L555.152 155.694L369.603 0L57.3167 113.918Z",
    fill: "#A90033"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M384.741 217.651L242.699 269.473L311.26 327.002L623.547 213.084L555.152 155.694L469.946 186.673L384.741 217.651Z",
    fill: "#A90033"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M269.627 566.203L581.253 451.731L511.543 393.237L285.596 475.823L269.627 566.203Z",
    fill: "#A90033"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M84.7327 411.058L269.627 566.203L285.596 475.823L169.985 379.466L84.7327 411.058Z",
    fill: "#A90033"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M0 440.476L253.944 653.56L269.627 566.203L84.7327 411.058L126.785 172.209L57.3167 113.918L0 440.476Z",
    fill: "#7B0025"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M353.678 89.7644L338.395 178.763L384.741 217.651L469.946 186.673L353.678 89.7644Z",
    fill: "#7B0025"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M311.26 327.002L242.699 269.473L227.034 358.15L295.978 416L311.26 327.002Z",
    fill: "#7B0025"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnomoLogo);
export default __webpack_public_path__ + "static/media/enomo_logo.3a06edc09a4d334b8d5f4bc568d70ad2.svg";
export { ForwardRef as ReactComponent };